import { DefaultFile, Language as LanguageFromPackage, mapLanguageFile } from "@jamezz/react-components";
import defaultsFile from "../../assets/langs/defaults.json";
import de from "../../assets/langs/de.json";
import da from "../../assets/langs/da.json";
import en from "../../assets/langs/en.json";
import es from "../../assets/langs/es.json";
import fr from "../../assets/langs/fr.json";
import it from "../../assets/langs/it.json";
import nl from "../../assets/langs/nl.json";
import nlBE from "../../assets/langs/nl-BE.json";
import sv from "../../assets/langs/sv.json";
import zh from "../../assets/langs/zh.json";
import ja from "../../assets/langs/ja.json";
import hr from "../../assets/langs/hr.json";
import ca from "../../assets/langs/ca.json";
import ar from "../../assets/langs/ar.json";
import uk from "../../assets/langs/uk.json";
import pl from "../../assets/langs/pl.json";

export type Language = LanguageFromPackage;
export type Translations<KEYS extends string> = {
  [lang: Partial<Language[number]>]: {
    [k in KEYS]: string;
  };
};

export type kiosk_custom_text_keys =
  | "kiosk - Orderpage order more button"
  | "kiosk - Orderpage checkout button"
  | "kiosk - Orderpage order button"
  | "kiosk - Orderpage goto checkout button";

export type arrangement_custom_text_keys = "Almost finished reminder - title" | "Almost finished reminder - body";
export type pay_after_custom_text_keys =
  | "payafter - title"
  | "payafter - body"
  | "payafter - cancel button"
  | "payafter - ok button";

export type allergens_and_preferences_custom_text_keys =
  | "allergens page - title"
  | "allergens_subtext"
  | "allergens page - hide toggle button text"
  | "tag_preferences_subtext";

export type custom_text_keys =
  | "voucher button text"
  | "Translate cash payment text in app"
  | "Translate online payment text in app"
  | "add_tip_message"
  | "checkout button"
  | "custom_age_verify_notification_checkbox_line"
  | "go to order button"
  | "pay button"
  | "order button"
  | "loyalty gift card - stepper name"
  | "loyalty page - title"
  | "loyalty rewards - description"
  | "loyalty rewards - account title"
  | "loyalty rewards - redeem disabled message"
  | "loyalty card scan - description"
  | "loyalty card scan - title"
  | "loyalty gift card - title"
  | "vouchers page - title"
  | "login page - description"
  | "menu page - save loyalty points button"
  | "register page - description"
  | "tag_preferences_subtext"
  | "order_article_page_back_button"
  | "login page - verification code name"
  | "check_table_is_open_message"
  | "check_table_is_closed_message"
  | "mwise loyalty - login header"
  | "mwise loyalty - login body"
  | "use_random_pincodes_enter_pincode_explanation"
  | "order_dispatch_error"
  | "no timeslots available message"
  | allergens_and_preferences_custom_text_keys
  | kiosk_custom_text_keys
  | arrangement_custom_text_keys
  | pay_after_custom_text_keys;

export type html_translations_keys =
  | "betweenOrderTitle"
  | "betweenOrderContent"
  | "betweenOrderOkText"
  | "betweenOrderCancelText"
  | "custom_age_verify_notification_message"
  | "infoSplashContent"
  | "infoSplashTitle"
  | "checkout_message";

export type upsell_translation_keys = "onceTitel" | "onceText";

export const LANGUAGES: { [key in Language]?: DefaultFile<typeof defaultsFile> } = {
  de: mapLanguageFile<typeof defaultsFile>(defaultsFile, de),
  da: mapLanguageFile<typeof defaultsFile>(defaultsFile, da),
  en: mapLanguageFile<typeof defaultsFile>(defaultsFile, en),
  es: mapLanguageFile<typeof defaultsFile>(defaultsFile, es),
  fr: mapLanguageFile<typeof defaultsFile>(defaultsFile, fr),
  it: mapLanguageFile<typeof defaultsFile>(defaultsFile, it),
  nl: mapLanguageFile<typeof defaultsFile>(defaultsFile, nl),
  "nl-BE": mapLanguageFile<typeof defaultsFile>(defaultsFile, nlBE),
  sv: mapLanguageFile<typeof defaultsFile>(defaultsFile, sv),
  zh: mapLanguageFile<typeof defaultsFile>(defaultsFile, zh),
  ja: mapLanguageFile<typeof defaultsFile>(defaultsFile, ja),
  hr: mapLanguageFile<typeof defaultsFile>(defaultsFile, hr),
  ca: mapLanguageFile<typeof defaultsFile>(defaultsFile, ca),
  ar: mapLanguageFile<typeof defaultsFile>(defaultsFile, ar),
  uk: mapLanguageFile<typeof defaultsFile>(defaultsFile, uk),
  pl: mapLanguageFile<typeof defaultsFile>(defaultsFile, pl),
};
